export const trainingenData = [
  {
    key: "gemeentelijke-professionals",
    titel: "Voor gemeentelijke professionals",
    subtitel: "Casemanagers, klantmanagers, participatiecoaches, wijkteams.",
    intro:
      "Een training voor de mensen die dagelijks met de doelgroep werken. Praktische handvatten voor gesprekken, herkennen van patronen, motivational interviewing, en aansluiten bij intrinsieke motivatie. Gebaseerd op de LevelLeven-methodiek: NLP, Systemisch werken, Transactionele Analyse en de Zelfdeterminatietheorie.",
    leerdoelen: [
      "Effectieve gespreksvoering met langdurig vastgelopen inwoners",
      "Herkennen van belemmerende patronen en systemische lasten",
      "Aansluiten bij intrinsieke motivatie (SDT)",
      "Volwassene-perspectief (TA) inzetten in dagelijkse gesprekken",
      "Herkaderen en ankertechnieken uit NLP",
    ],
    resultaat:
      "Deelnemers verlaten de training met een direct toepasbaar gespreksrepertoire, meer rust in complexe casuïstiek en een gedeeld vocabulaire binnen het team.",
    duur: "2 dagen (of 4 dagdelen)",
    groep: "8-12 deelnemers",
    data: "Op afspraak · start binnen 6 weken",
    prijs: "Op aanvraag, gebaseerd op groepsgrootte en maatwerk",
    certificering: "Ja, na afronding",
    referenties: ["ryan-deci", "vos-vanrijn", "morris"],
  },
  {
    key: "werkgevers",
    titel: "Voor werkgevers",
    subtitel: "Voor bedrijven die deelnemers uit het programma overnemen.",
    intro:
      "Wanneer een deelnemer uitstroomt naar werk, is het cruciaal dat de nieuwe werkomgeving weet hoe zij deze mensen duurzaam kunnen begeleiden. Wij trainen leidinggevenden en collega's om te bouwen op wat de deelnemer al heeft geleerd, niet om alles opnieuw te doen.",
    leerdoelen: [
      "Onboarding voor werknemers met een lange afstand tot de arbeidsmarkt",
      "Signalen van terugval, en hoe te reageren",
      "Buddy- en mentor-vaardigheden op de werkvloer",
      "Realistische verwachtingen en tempo",
    ],
    resultaat:
      "Een werkomgeving die de nieuwe medewerker houdt in plaats van verliest, duurzame plaatsing in plaats van herhaalinstroom in de uitkering.",
    duur: "1 dag + follow-up dagdeel na 8 weken",
    groep: "6-10 deelnemers",
    data: "Op afspraak · start binnen 6 weken",
    prijs: "Op aanvraag",
    certificering: "Bewijs van deelname",
    referenties: ["kersten", "arena", "liu"],
  },
  {
    key: "uwv",
    titel: "Voor UWV",
    subtitel: "Speciaal programma voor UWV-medewerkers.",
    intro:
      "Voor arbeidsdeskundigen, re-integratiespecialisten en werkbegeleiders van het UWV. Focus op de doelgroep die met WW of WIA vastloopt op meerdere leefgebieden tegelijk, waar de standaard re-integratie niet volstaat.",
    leerdoelen: [
      "Multiproblematiek herkennen zonder te labelen",
      "Van diagnose naar activering, de tussenfase invullen",
      "Samenwerken met welzijnspartners en gemeente",
      "Case-regie vanuit vertrouwen in plaats van controle",
    ],
    resultaat:
      "Meer trajecten die daadwerkelijk in beweging komen. Minder terugval na eerdere re-integratie-inspanningen.",
    duur: "2 dagen",
    groep: "8-12 deelnemers",
    data: "Op afspraak",
    prijs: "Op aanvraag",
    certificering: "Ja, na afronding",
    referenties: ["paul-moser", "mckee-ryan", "pohlan"],
  },
  {
    key: "mbo",
    titel: "Voor MBO-scholen",
    subtitel: "Voor mentoren, studieloopbaanbegeleiders en zorgcoördinatoren.",
    intro:
      "MBO-scholen zien studenten die zonder passende begeleiding uitvallen en soms rechtstreeks in de bijstand belanden. Wij trainen begeleiders om vroegtijdig te herkennen wat er speelt en gerichter te interveniëren, vóór het traject stukloopt.",
    leerdoelen: [
      "Vroegtijdig signaleren van (multi-)problematiek",
      "Gedragsverandering bij jongvolwassenen",
      "Warme overdracht naar gemeente of zorgpartner",
      "Systemisch kijken naar het gezin achter de student",
    ],
    resultaat:
      "Minder ongeplande uitval. Studenten die eerder de passende hulp krijgen, voordat ze in het bijstandssysteem belanden.",
    duur: "2 dagen",
    groep: "8-12 deelnemers",
    data: "Op afspraak",
    prijs: "Op aanvraag",
    certificering: "Ja, na afronding",
    referenties: ["ryan-deci", "morris", "kersten"],
  },
  {
    key: "verzekeraars",
    titel: "Voor verzekeraars",
    subtitel: "Voor case-coördinatoren en re-integratieadviseurs.",
    intro:
      "Bij verzuim en WGA-instroom is de mens achter het dossier vaak buiten beeld. LevelLeven biedt verzekeraars een training die case-coördinatoren helpt om écht contact te maken, patronen te doorbreken en re-integratie duurzaam te maken.",
    leerdoelen: [
      "Herstel-gericht werken zonder medicaliseren",
      "Duurzame re-integratie na langdurig verzuim",
      "Regievoering vanuit vertrouwen, niet vanuit controle",
      "Systemische factoren in verzuim herkennen",
    ],
    resultaat:
      "Korter verzuim, duurzamere re-integratie, minder herhaalinstroom in WGA. Betere gesprekken met verzekerden.",
    duur: "2 dagen",
    groep: "8-12 deelnemers",
    data: "Op afspraak",
    prijs: "Op aanvraag",
    certificering: "Ja, na afronding",
    referenties: ["vos-vanrijn", "arena", "dehaan-nilsson"],
  },
];

export const referenties = {
  "ryan-deci": "Ryan, R. M., & Deci, E. L. (2000). Self-determination theory and the facilitation of intrinsic motivation, social development, and well-being. American Psychologist, 55(1), 68–78.",
  "vos-vanrijn": "Vos, J., & Van Rijn, B. (2022). The effectiveness of Transactional Analysis treatments and their predictors. Journal of Humanistic Psychology.",
  "morris": "Morris, T. H. (2020). Experiential learning – A systematic review and revision of Kolb's model. Interactive Learning Environments, 28(8), 1064–1077.",
  "kersten": "Kersten, A., et al. (2023). Organisational policies and practices for the inclusion of vulnerable workers: A systematic review. Journal of Occupational Rehabilitation.",
  "arena": "Arena, A. F., et al. (2023). Mental health and unemployment: A systematic review and meta-analysis. Journal of Affective Disorders, 335, 450–472.",
  "liu": "Liu, S., Huang, J. L., & Wang, M. (2014). Effectiveness of job search interventions: A meta-analytic review. Psychological Bulletin, 140(4), 1009–1041.",
  "paul-moser": "Paul, K. I., & Moser, K. (2009). Unemployment impairs mental health: Meta-analyses. Journal of Vocational Behavior, 74(3), 264–282.",
  "mckee-ryan": "McKee-Ryan, F. M., et al. (2005). Psychological and physical well-being during unemployment: A meta-analytic study. Journal of Applied Psychology, 90(1), 53–76.",
  "pohlan": "Pohlan, L. (2019). Unemployment and social exclusion. Journal of Economic Behavior & Organization.",
  "dehaan-nilsson": "De Haan, E., & Nilsson, V. O. (2023). What can we know about the effectiveness of coaching? A meta-analysis based only on randomized controlled trials. Academy of Management Learning & Education.",
  "sturt": "Sturt, J., et al. (2012). Neurolinguistic programming: A systematic review. British Journal of General Practice, 62(604), e757–e764.",
};
